export default __webpack_public_path__ + "static/media/escudo.447f15ee.svg";